module.exports = __webpack_public_path__ + "img/3_98.bdc27b18.png";